import { PEOPLE } from 'src/Actions/People/types';

export const initialState = {
  people: {},
  offset: 1,
  customersLoading: false,
  subscriptionLicenseList: {},
}

const peopleReducer = (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case PEOPLE.GET_PEOPLE: {
      let { offset } = action;

      return {
        ...state,
        customersLoading: offset === 1 ? true : false,
      }
    }

    case PEOPLE.GET_PEOPLE_SUCCESS: {
      let { response } = action;

      return {
        ...state,
        people: response,
        customersLoading: false,
        peopleList: response
      }
    }

    case PEOPLE.GET_PEOPLE_FAILURE: {
      let { error } = action;
      return {
        ...state,
        customersLoading: false,
        people: error,
        peopleList: [],
        error,
      }
    }

    default: {
      return {
        ...state,
      }
    }
  }
}

export default peopleReducer;